import { render, staticRenderFns } from "./modifyPriceControl.vue?vue&type=template&id=4c04a15b&scoped=true"
import script from "./modifyPriceControl.vue?vue&type=script&lang=js"
export * from "./modifyPriceControl.vue?vue&type=script&lang=js"
import style0 from "./modifyPriceControl.vue?vue&type=style&index=0&id=4c04a15b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c04a15b",
  null
  
)

export default component.exports